import React, { useRef,useEffect,useMemo} from "react";
import {
  Button,
  FormGroup,
  Input,
  Row,
  Col,
  Spinner,
  ModalFooter,
} from "reactstrap";
import { useHistory,useLocation} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { saveBankDetails,getBankDetails,setIsBankUpdated} from "store/reducers/common.slice";
import "../../assets/scss/mobile/styleMobile.scss";

export default function UserBank() {
  const dispatch = useDispatch();
  const history = useHistory();
  const formRef = useRef(null);
  const location = useLocation();
  const bankData = location.state?.bankData;
  const initialBankValues = useMemo(() => ({
      bankId: bankData?.id || 0,
      upiId: bankData?.bankUPI || "",
      beneficiaryName: bankData?.bankHolderName || "",
      bankName: bankData?.bankName || "",
      ifscCode: bankData?.bankIFSC || "",
      accountNumber: bankData?.bankAccountNumber || "",
  }), [bankData]);
  const { userBankLoading,isBankUpdated} = useSelector(
    ({ common }) => common
  );   
  const validationBankSchema = Yup.object().shape({
    upiId: Yup.string()
      .matches(/^[\w.-]+@[\w]+$/, "Enter a valid UPI ID")
      .required("UPI ID is required"),
    beneficiaryName: Yup.string().required("Beneficiary Name is required"),
    bankName: Yup.string().required("Bank Name is required"),
    ifscCode: Yup.string()
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC Code")
      .required("IFSC Code is required"),
    accountNumber: Yup.string().required("Account Number is required"),
  });
  useEffect(() => {
    if (isBankUpdated) {
      dispatch(setIsBankUpdated(false));
      history.push('/app/withdrawal', { activeTab: "2" });
    }
  }, [isBankUpdated]);
  return (
    <main className="trade_page">
      <header>
        <div className="confirm_order_header">
          <div className="close_icon">
            <span
              className="material-symbols-outlined"
              onClick={() => history.push('/app/withdrawal', { activeTab: "2" })}
            >
              keyboard_backspace
            </span>{" "}
            <span>{bankData?'Edit':'Add'} Bank Account</span>
          </div>
        </div>
      </header>
      <div className="orderBook_tabs my-6">
      {userBankLoading &&
        <div className="spinner-box">
          <Spinner className="ml-2" color="primary" />
        </div>
      }
        <Formik
          initialValues={initialBankValues}
          validationSchema={validationBankSchema}
          onSubmit={(values) => dispatch(saveBankDetails(values))}
          innerRef={formRef}
        >
          {() => (
            <div className="card">
              <div className="card-body">
                <Form>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="upiId" placeholder="Enter UPI ID" />
                        <span className="text-error"><ErrorMessage name="upiId" /></span>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="beneficiaryName" placeholder="Enter Beneficiary Name" />
                        <span className="text-error"><ErrorMessage name="beneficiaryName" /></span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="bankName" placeholder="Enter Bank Name" />
                        <span className="text-error"><ErrorMessage name="bankName" /></span>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="ifscCode" placeholder="Enter IFSC Code" />
                        <span className="text-error"><ErrorMessage name="ifscCode" /></span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="accountNumber" placeholder="Enter Account Number" />
                        <span className="text-error"><ErrorMessage name="accountNumber" /></span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <ModalFooter>
                    <Button type="submit" color="default" className="w-100 py-2 btn-icon btn-3 mt-0">Submit</Button>
                  </ModalFooter>
                </Form>
              </div>
            </div>
          )}
        </Formik>
      </div>
    </main>
  );
}
